export const usersInitialState = {
  users: {
    data: [],
    meta: {
      isLoading: false,
      hasError: false
    }
  }
};
